// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PropertyMessageMessage__propertyMessageMessage___dnz p{margin:0 0 12px 0}`, "",{"version":3,"sources":["webpack://./components/PropertyMessageMessage.scss"],"names":[],"mappings":"AASI,wDACI,iBAAA","sourcesContent":["@import '../vars.scss';\n\n.propertyMessageMessage {\n    // textarea {\n    //   width: 100%;\n    //   min-height: 100px;\n    //   padding: 19px 9px 5px 9px;\n    // }\n\n    p {\n        margin: 0 0 12px 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"propertyMessageMessage": `PropertyMessageMessage__propertyMessageMessage___dnz`
};
export default ___CSS_LOADER_EXPORT___;
